import React, { memo, PropsWithChildren, useCallback } from "react";
import { QParkSelectCardItemProps } from "./QParkSelectCardItem.types";
import { DoneRounded, InfoOutlined } from "@material-ui/icons";
import { isUndefined } from "underscore";
import "./_qpark-select-card-item.scss";

const QParkSelectCardItem = memo(
  (props: PropsWithChildren<QParkSelectCardItemProps>) => {
    const { selected, children, value, onClick, description } = props;

    const isSelected = selected === value;
    const hasDescription = description && description.trim().length > 0;

    const onCardItemClicked = useCallback(
      (value?: string | number) => (_: React.MouseEvent<HTMLLIElement>) => {
        if (isUndefined(onClick)) {
          return;
        }

        onClick(value);
      },
      [value, onClick]
    );

    return (
      <li
        className={`qp-select-card ${isSelected ? "active" : ""}`.trim()}
        value={value}
        onClick={onCardItemClicked(value)}
      >
        <div className="qp-select-card-check">
          <div className="check-icon-wrapper">
            <DoneRounded className="check-icon" />
          </div>
        </div>
        <span className="qp-select-card-label">
          <span>{children}</span>
        </span>
        {hasDescription && (
          <div className="qp-select-card-info">
            <InfoOutlined className="info-icon" />
            <span className="info-tooltip">{description}</span>
          </div>
        )}
      </li>
    );
  }
);

export default QParkSelectCardItem;
